import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createElementOrNullndtuwori8mbn as createElementOrNull } from './createElementOrNull.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function FC(block) {
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return (props) => createElementOrNull(($this$createElementOrNull) => {
    block($this$createElementOrNull, props);
    return Unit_instance;
  });
}
function FC_0(block) {
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return () => createElementOrNull(block);
}
function FC_1(displayName, block) {
  var component = FC(block);
  component.displayName = displayName;
  return component;
}
//region block: exports
export {
  FC_0 as FC2myqnqrb760jo,
  FC_1 as FC1sdpbda2hq7ca,
  FC as FCjj9oni2aqo4w,
};
//endregion

//# sourceMappingURL=FC.mjs.map
